import axios from '../../axios'

// 新增专业详情
export const addProfDetail = (data) => {
    return axios({
        url: '/api/data/wish/prof/detail',
        method: 'POST',
        data
    })
}

// 修改专业详情信息
export const editProfDetail = (data) => {
    return axios({
        url: '/api/data/wish/prof/detail',
        method: 'PUT',
        data
    })
}

// 删除专业详情信息
export const deleteProfDetail = (data) => {
    return axios({
        url: '/api/data/wish/prof/detail',
        method: 'DELETE',
        data
    })
}

// 根据信息综合搜索专业详情信息列表
export const searchProfDetailList = (data) => {
    return axios({
        url: '/api/data/wish/prof/detail',
        method: 'GET',
        data
    })
}

// 获取专业详情详情
export const getProfDetailInfo = (data) => {
    return axios({
        url: '/api/data/wish/prof/detail/info',
        method: 'GET',
        data
    })
}



// WEBPACK FOOTER //
// ./src/http/moudules/dataManage/profdetail.js